import { SET_MYPLANS_DATA, MYPLANS_FETCH_INIT, DATA_FETCH_INIT } from "./types";
const initialState = {
  //register plan variables
  register_plan_popup: false,
  registrations_list: [],
  total_registrations: 0,
  registrations_page: 1,
  registrations_perpage: 20,
  registrations_search: "",
  registrations_list_refetch: false,
  registrations_list_refetch_force: false,
  //create registration vars
  register_plan_edit_popup: false,
  Ereg_ppe_plan_id: "",
  Ereg_end_user_name: "",
  Ereg_csp_status: "",
  Ereg_product_so: "",
  Ereg_technology: "",
  Ereg_size: "",
  Ereg_total_spend: "",
  Ereg_total_rebate: "",
  Ereg_status: "",
  Ereg_submission_date: new Date(),
  Ereg_registered_track: "",
  Ereg_registered_site: "",
  Ereg_country: "",
  Ereg_details: {},
  is_partner_edit_disabled: false,

  //delete registration vars
  delete_plan_popup: false,
  Del_plan_details: null,

  //Filter plans registration
  filter_plans_popup: false,
  filter_data_list: {},
  filter_data: {
    technology: [],
    status: [],
    end_user_name: [],
    size: [],
    partner: [],
    cspDocumentStatus: [],
    boDocumentStatus: [],
    dealId: [],
  },
  filter_choice_disable: false,
  applied_filter_data: {
    technology: [],
    status: [],
    end_user_name: [],
    size: [],
    partner: [],
    cspDocumentStatus: [],
    boDocumentStatus: [],
    dealId: [],
  },
  available_filters: [],

  // vendor opts
  vendor_opts: [],

  // Kit List
  adoptKitPage: 1,
  adoptKitPerpage: 5,
  adoptKitRefetch: false,
  adoptKitCount: 0,
  kitPlanId: 0,
  adoptKitAwsRegion: null,
  isAdoptKitLoading: false,
  isKitListOpen: false,
  adoptKitList: [],
  // document
  document_preview_popup: false,
  document_preview_details: {},
  update_profile_popup: false,
  update_org_profile_id: "",
  //For end user popup
  end_user_popup: false,
  selected_end_user_plan: {
    cspDocument: {},
    bo_document: {},
  },
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_MYPLANS_DATA:
      return { ...state, ...action.payload };
    case MYPLANS_FETCH_INIT:
      return {
        ...state,
        registrations_list_refetch: false,
        registrations_list_refetch_force: false,
        isDataLoading: true,
        ...action.payload,
      };

    case DATA_FETCH_INIT:
      return { ...state, isDataLoading: true, ...action.payload };
    default:
      return state;
  }
};
